import angular from 'angular';
import csmCommonWeb from 'csm-common-web';

import dialogTemplate from './addChangeClassDialog.template.html';
import './addChangeClassDialog.css';

export default angular
  .module('books.dialogs.addChangeClassDialog', [csmCommonWeb])
  .directive('addChangeClassDialog', addChangeClassDialogDirective)
  .name;
  
addChangeClassDialogDirective.$inject = [];

/*****************************************************************************
 * Directive: addChangeClassDialog
 *
 * This directive provides content for managing class information. The cancel
 * and commit expression are executed upon the respective button click.
 *
 *  @attr class      {object}     - Class model object
 *  @attr classLabel {string}     - Class label to display in the dialog title
 *  @attr cancel     {expression} - Expression to evaluate on cancel
 *  @attr commit     {expression} - Expression to evaluate on a commit
 *  @attr noteLabel  {string}     - Optional Note field label
 *****************************************************************************/
/* @ngInject */ function addChangeClassDialogDirective() {
  return {
    restrict: 'E',
    scope: {
      class: '=',
      classLabel: '@',
      cancel: '&',
      commit: '&',
      noteLabel: '@'
    },
    template: dialogTemplate,
    link: function (scope) {
      /** Validator Object. */
      scope.validator = {};

      /** Dialog Header Text. */
      scope.header = function () {
        return '{0} {1}'.format(
          !scope.isNew() ? 'Change' : 'Add New',
          scope.classLabel
        );
      };

      /** New Class Indicator. */
      scope.isNew = function () {
        return scope.class && !scope.class.id;
      };

      /** Note display label. */
      scope.noteDisplay = function () {
        return scope.noteLabel || 'Notes';
      };

      /*************************************************************************
       * save */
      /**
       * Ensures all fields are valid before executing the commit expression.
       *************************************************************************/
      scope.save = function () {
        if (!scope.validator.validate()) return;

        /*--------------------------------------------------*/
        /* For a new class, set the active property to true */
        /*--------------------------------------------------*/
        if (scope.isNew()) scope.class.active = true;

        scope.commit();
      };
    }
  };
}
